export const state = {
  ocrBoxInfo: {
    show: false,
    step: 1
  },
  businessLicenseImage: {},
  businessLicenseInfo: {},
  currentAreaCode: '23',
  userInfo: {}
};
